
import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";
import { mockLineData } from "../data/mockData";

// Convert time strings to numerical hours
const timeToHour = (time) => {
  const [hours] = time.split(':');
  return parseInt(hours, 10);
};

const CustomLineChart = ({ isDashboard = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Transform data to use numerical x values
  const transformedData = mockLineData.map(line => ({
    ...line,
    data: line.data.map(point => ({
      ...point,
      x: timeToHour(point.x)
    }))
  }));

  return (
    <ResponsiveContainer width="100%" height={isDashboard ? 250 : 400}>
      <LineChart
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke={colors.grey[100]} />
        <XAxis
          dataKey="x"
          type="number"
          domain={[0, 24]}
          stroke={colors.grey[100]}
          tick={{ fill: colors.grey[100] }}
          ticks={[0, 6, 12, 18, 24]}
          tickFormatter={(value) => {
            if (value === 24) return '00:00';
            return `${value.toString().padStart(2, '0')}:00`;
          }}
        />
        <YAxis
          stroke={colors.grey[100]}
          tick={{ fill: colors.grey[100] }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: colors.primary[400],
            border: `1px solid ${colors.grey[100]}`,
            borderRadius: "4px",
          }}
          formatter={(value, name) => [
            value.toFixed(2),
            name
          ]}
          labelFormatter={(label) => {
            if (label === 24) return '00:00';
            return `${label.toString().padStart(2, '0')}:00`;
          }}
        />
        <Legend
          wrapperStyle={{
            paddingTop: "10px",
          }}
        />
        {transformedData.map((line) => (
          <Line
            key={line.id}
            type="monotone"
            dataKey="y"
            data={line.data}
            name={line.id}
            stroke={line.color}
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
            isAnimationActive={true}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CustomLineChart;